import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { ConnectionsPage } from '../pages/ConnectionsPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/connections')({
  component: Connections,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
})

function Connections() {
  return (
    <MainLayout>
      <ConnectionsPage />
    </MainLayout>
  )
}
